import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";
import {
  ArrowBackIos,
  ArrowForward,
  ArrowForwardIos,
} from "@mui/icons-material";
import Header from "./Header";
import Footer from "./Footer";
import banner from "../assets/banner7.png";
import banner1 from "../assets/banner3.png";
import banner2 from "../assets/banner4.png";
import banner3 from "../assets/banner5.png";
import banner4 from "../assets/banner6.png";
import b1 from "../assets/b1.png";
import b2 from "../assets/b2.png";
import b3 from "../assets/b3.png";
import b4 from "../assets/b4.png";
import b5 from "../assets/b5.png";
import cow1 from "../assets/cow1.jpg";
import cow2 from "../assets/cow2.jpg";
import cow3 from "../assets/cow3.png";
import cow4 from "../assets/cow4.png";
import cow5 from "../assets/cow5.jpg";
import image from "../assets/image.png";
import a1 from "../assets/a1.png";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
const banners = [banner1, banner2, banner3, banner4];
const videoId = "ijoyg3L5kFk?si";

const cardsData = [
  {
    img: banner1,
    title: "Free Milk Distribution",
    desc: "Small quantity of Milk produces in our gaushala is freely distributed to saints, gausewaks, ashrams and in charitable hospitals in Haridwar/Rishikesh. We do not engage in the commercial sale of milk or milk products. By offering this free distribution, we aim to support the well-being and nutritional needs of individuals and organizations dedicated to spiritual pursuits, animal welfare, and charitable endeavors. It is our humble contribution to foster a spirit of sharing and compassion within our community.",
  },
  {
    img: banner2,
    title: "Cow Care Services",
    desc: "We provide medical treatment, shelter, and nourishment to cows in need, ensuring their health and well-being. Our gaushala is committed to protecting abandoned and injured cows.",
  },
  {
    img: banner3,
    title: "Organic Farming",
    desc: "Using cow dung and urine, we promote sustainable organic farming practices, reducing chemical dependency and preserving soil fertility.",
  },
  {
    img: banner4,
    title: "Community Engagement",
    desc: "Our initiatives involve local communities in awareness programs, workshops, and events to spread knowledge of cow protection and eco-friendly living.",
  },
  {
    img: banner4,
    title: "Spiritual Programs",
    desc: "We organize satsangs, yoga sessions, and meditation programs within our gaushala to promote spiritual growth along with animal care.",
  },
];
const achievementsData = [
  {
    title: "Media Coverage and Public Recognition",
    description:
      "Our activities have not gone unnoticed by the public or the Local newspapers, news channels & other print media have covered our initiatives, shedding light on the positive impact we are making in our communities. This recognition serves as a testament to the significance of our work and inspires us to continue striving for excellence in all our endeavours.",
    image: image,
  },
  {
    title: "Community Service Awards",
    description:
      "We have been honored with multiple community service awards for our consistent efforts in supporting Gauvansh welfare and other social initiatives, demonstrating our commitment and impact.",
    image: banner1,
  },
  {
    title: "Government Recognition",
    description:
      "Our organization has received official recognition from governmental bodies for our projects, further validating our dedication and hard work in social welfare.",
    image: image,
  },
  {
    title: "Volunteer Appreciation",
    description:
      "Countless volunteers have expressed appreciation for the meaningful work they have contributed to, making our initiatives more impactful and far-reaching.",
    image: banner1,
  },
  {
    title: "Sustainable Development Impact",
    description:
      "Our projects focus on sustainable and ethical practices, positively impacting the environment and community, earning accolades from experts and organizations alike.",
    image: image,
  },
];
const cards = [
  { title: "Gauvansh Medicated", action: "51K" },
  { title: "Number of Gaushala", action: "11" },
  { title: "Gauvansh Sheltered", action: "21k" },
  { title: "Number of States", action: "5" },
];
const accreditations = [
  { img: a1, text: "Madhya Pradesh Gausewa Ayog" },
  { img: a1, text: "Registered under section 80G of the Income Tax Act" },
  { img: a1, text: "Recognition 3" },
  { img: a1, text: "Recognition 4" },
  { img: a1, text: "Recognition 5" },
];
const sewa = [
  {
    title: " Celebrate Birthday/ Anniv/ Event",
    description:
      "We at Krishnayan can help you by making your auspicious day bestowed with abundant blessings and turn your contributions... ",
    image: b1,
  },
  {
    title: "Yagya / Pooja / Food Distribution",
    description:
      "Yagya is performed to invoke Gods for their blessings and to seek a peaceful and healthy life.",
    image: b2,
  },
  {
    title: " Food For Under Privileged",
    description:
      "Life is really tough without food. With your support, Krishnayan spread love and happiness through its free food distribution initiative",
    image: b3,
  },
  {
    title: "Shradh for Departed Souls",
    description:
      "Shradh is a ritual to pay homage to one's deceased family members or ancestors. You can choos...",
    image: b4,
  },
  {
    title: "Service to mother cow",
    description:
      "Shree Krishnayan Desi Gauraksha shelters destitute cows & bulls which are rescued from various locations surrounding our Gaushalas.",
    image: b5,
  },
];
const adopt = [
  {
    image: cow1,
    categary: "Female_calf",
    breed: "BADRI",
    date: "29-Nov-2024",
    age: "11 Months",
  },
  {
    image: cow2,
    categary: "Cow",
    breed: "RATHI",
    date: "13-Sep-2024",
    age: "6 Year 9 Months",
  },
  {
    image: cow3,
    categary: "Cow",
    breed: "MEWATHI",
    date: "13-Oct-2019",
    age: "5 Year 9 Months",
  },
  {
    image: cow4,
    categary: "Male_calf",
    breed: "BADRI",
    date: "06-Oct-2019",
    age: "5 Year 9 Months",
  },
  {
    image: cow5,
    categary: "Male_calf",
    breed: "BADRI",
    date: "06-Oct-2019",
    age: "5 Year 9 Months",
  },
];
const blog = [
  {
    image: cow1,
    title: "Sustainable Cow Care Tips",
    date: "2025-08-01",
  },
  {
    image: cow1,
    title: "Healthy Calf Nutrition",
    date: "2025-08-05",
  },
  {
    image: cow1,
    title: "Farm Life Essentials",
    date: "2025-08-10",
  },
  {
    image: cow1,
    title: "Organic Fodder Benefits",
    date: "2025-08-15",
  },
  {
    image: cow1,
    title: "Daily Care Routine",
    date: "2025-08-20",
  },
];
const testimonials = [
  {
    img: "https://via.placeholder.com/100",
    name: "Shri Kailash Kher",
    role: "Composer & Playback Singer",
    text: "The initiatives taken by Shree Krishnayan make gauvansh happy.",
  },
  {
    img: "https://via.placeholder.com/100",
    name: "Shri Trivendra Singh Rawat",
    role: "Ex-CM, Present MP",
    text: "I am experiencing inner peace here.",
  },
  {
    img: "https://via.placeholder.com/100",
    name: "Shree Mohan Yadav",
    role: "CM, Madhya Pradesh",
    text: "Grateful to Shree Krishnayan Gaushala for dedication to cow service.",
  },
  {
    img: "https://via.placeholder.com/100",
    name: "Another Person",
    role: "Guest",
    text: "Beautiful atmosphere and divine service.",
  },
  {
    img: "https://via.placeholder.com/100",
    name: "Fifth Person",
    role: "Supporter",
    text: "Blessed to be part of this seva.",
  },
];

const Gaudaan = () => {
  const [index, setIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedCard, setExpandedCard] = React.useState(null);
  const [shift, setShift] = useState(0);
  const isMobile = useMediaQuery("(max-width:600px)");
  const visibleCount = isMobile ? 1 : 5;
  const cardWidth = 220;
  const gap = 16;
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };
  const itemVariantsLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariantsRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setShift((prev) => (prev + 1) % accreditations.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const carouselItems = [...accreditations, ...accreditations];

  const [readMore, setReadMore] = React.useState(
    achievementsData.map(() => false)
  );
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % accreditations.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const toggleReadMore = (i) => {
    setReadMore((prev) => ({ ...prev, [i]: !prev[i] }));
  };
  const goToPrevious = () => {
    setStartIndex(
      (prev) => (prev - 1 + achievementsData.length) % achievementsData.length
    );
  };

  const goToNext = () => {
    setStartIndex((prev) => (prev + 1) % achievementsData.length);
  };

  const toggleDescription = (i) => {
    const updatedStates = [...readMore];
    updatedStates[i] = !updatedStates[i];
    setReadMore(updatedStates);
  };
  const visibleCards = [
    achievementsData[startIndex],
    achievementsData[(startIndex + 1) % achievementsData.length],
    achievementsData[(startIndex + 2) % achievementsData.length],
  ];

  const handleCardClick = (i) => {
    setExpandedCard(expandedCard === i ? null : i);
  };

  // cards
  const getPositiond = (i) => {
    const diff = (i - index + cardsData.length) % cardsData.length;
    if (diff === 0) return "center";
    if (diff === 1) return "right";
    if (diff === cardsData.length - 1) return "left";
    return "hidden";
  };

  const handleNexts = () => {
    setIndex((prev) => (prev + 1) % cardsData.length);
  };

  const handlePrevs = () => {
    setIndex((prev) => (prev - 1 + cardsData.length) % cardsData.length);
  };

  useEffect(() => {
    const timer = setInterval(handleNexts, 3000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(handleNext, 5000);
    return () => clearInterval(timer);
  }, []);
  //banner
  const handleNext = () => {
    setIndex((prev) => (prev + 1) % banners.length);
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const getPosition = (i) => {
    const diff = (i - index + banners.length) % banners.length;
    if (diff === 0) return "center";
    if (diff === 1) return "right";
    if (diff === banners.length - 1) return "left";
    return "hidden";
  };

  //cards
  const handleCardPrev = () =>
    setIndex((prev) => (prev - 1 + cards.length) % cards.length);
  const handleCardNext = () => setIndex((prev) => (prev + 1) % cards.length);

  const getCardPosition = (i) => {
    const diff = (i - index + cards.length) % cards.length;
    if (diff === 0) return { scale: 1, x: 0, zIndex: 3, opacity: 1 };
    if (diff === 1 || diff === -(cards.length - 1))
      return { scale: 0.8, x: "70%", zIndex: 2, opacity: 0.7 };
    if (diff === cards.length - 1 || diff === -1)
      return { scale: 0.8, x: "-40%", zIndex: 2, opacity: 0.7 };
    return { scale: 0.6, x: 0, zIndex: 1, opacity: 0 };
  };

  //adopt
  const getAdoptPosition = (i) => {
    let diff = (i - currentIndex + adopt.length) % adopt.length;
    if (diff === 0) return "center";
    if (diff === 1) return "right1";
    if (diff === 2) return "right2";
    if (diff === adopt.length - 1) return "left1";
    if (diff === adopt.length - 2) return "left2";
    return "hidden"; // anything else
  };

  const handleAdoptNext = () => {
    setCurrentIndex((prev) => (prev + 1) % adopt.length);
  };

  const handleAdoptPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + adopt.length) % adopt.length);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % adopt.length);
    }, 5000); // 5000ms = 5 seconds

    return () => clearInterval(interval);
  }, [sewa.length]);

  // blog
  useEffect(() => {
    const interval = setInterval(() => {
      Next();
    }, 5000);
    return () => clearInterval(interval);
  }, [blog.length]);

  const Prev = () =>
    setCurrentIndex((prev) => (prev - 1 + blog.length) % blog.length);
  const Next = () => setCurrentIndex((prev) => (prev + 1) % blog.length);

  const getBlogPosition = (i) => {
    const total = blog.length;
    let diff = i - currentIndex;

    // Wrap around circularly
    if (diff < -Math.floor(total / 2)) diff += total;
    if (diff > Math.floor(total / 2)) diff -= total;

    if (diff === 0) return "center";
    if (diff === -1) return "left1";
    if (diff === -2) return "left2";
    if (diff === 1) return "right1";
    if (diff === 2) return "right2";
    return "hidden"; // all others
  };

  //review
  const nextSlide = () => setIndex((prev) => (prev + 1) % testimonials.length);
  const prevSlide = () =>
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  const getSlidPosition = (i) => {
    const diff = (i - index + testimonials.length) % testimonials.length;
    if (diff === 0) return "center";
    if (diff === 1) return "right";
    if (diff === testimonials.length - 1) return "left";
    return "hidden";
  };

  return (
    <>
      <Header />
      <Box sx={{ mt: 10 }}>
        <Box
          sx={{
            height: { xs: "150px", md: "450px" },
            position: "relative",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {banners.map((banner, i) => {
            const pos = getPosition(i);
            let style = {};
            if (pos === "center") {
              style = { scale: 1, x: 0, zIndex: 3, opacity: 1 };
            } else if (pos === "left") {
              style = { scale: 0.8, x: "-60%", zIndex: 2, opacity: 0.9 };
            } else if (pos === "right") {
              style = { scale: 0.8, x: "60%", zIndex: 2, opacity: 0.9 };
            } else {
              style = { scale: 0.5, opacity: 0, zIndex: 1 };
            }

            return (
              <motion.img
                key={i}
                src={banner}
                animate={style}
                transition={{ duration: 1 }}
                style={{
                  position: "absolute",
                  width: "80%",
                  height: { xs: "100%", md: 400 },
                  objectFit: "cover",
                  borderRadius: 15,
                }}
              />
            );
          })}

          {/* Left Arrow */}
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: { xs: 5, md: 15 },
              top: "50%",
              transform: "translateY(-50%)",
              color: "red",
              bgcolor: "rgba(255,255,255,0.7)",
              "&:hover": {
                bgcolor: "white",
              },
              zIndex: 4,
              p: { xs: 0.5, md: 1.5 }, // smaller button on mobile
            }}
          >
            <ArrowBackIos fontSize="small" />
          </IconButton>

          {/* Right Arrow */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: { xs: 5, md: 15 },
              top: "50%",
              transform: "translateY(-50%)",
              color: "red",
              bgcolor: "rgba(255,255,255,0.7)",
              "&:hover": {
                bgcolor: "white",
              },
              zIndex: 4,
              p: { xs: 0.5, md: 1.5 },
            }}
          >
            <ArrowForwardIos fontSize="small" />
          </IconButton>
        </Box>
        {/* <Box
          sx={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            backgroundColor: "#fff",
            borderTop: "3px solid #6d1675",
            borderBottom: "3px solid #6d1675",
            padding: "6px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              whiteSpace: "nowrap",
              animation: "scrollText 15s linear infinite",
            }}
          >
            {[...Array(10)].map((_, idx) => (
              <Box key={idx} sx={{ display: "flex", ml: "30px" }}>
                <Typography
                  sx={{
                    mx: 3,
                    fontWeight: "bold",
                    fontSize: { xs: "14px", md: "18px" },
                  }}
                >
                  Become A Volunteer,{" "}
                  <span style={{ color: "#ffc20f" }}>Click here</span>
                </Typography>
              </Box>
            ))}
          </Box>

          <style>
            {`
              @keyframes scrollText {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
            `}
          </style>
        </Box> */}
        <Box
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          sx={{
            // bgcolor: "#f7e1d4",
            color: "white",
            p: { xs: 2, md: 8 },
            position: "relative",
            overflow: "hidden",
          }}
        >
          <motion.span
            aria-hidden
            style={{
              position: "absolute",
              right: "-10%",
              top: "10%",
              width: "600px",
              height: "600px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.06)",
              filter: "blur(40px)",
              zIndex: 0,
            }}
            initial={{ scale: 0.9, opacity: 0.8 }}
            animate={{ scale: [1, 1.06, 1], opacity: [0.9, 1, 0.9] }}
            transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
          />

          <Grid container spacing={5} sx={{ position: "relative", zIndex: 1 }}>
            <Grid
              component={motion.div}
              variants={itemVariantsLeft}
              size={{ xs: 12, md: 6 }}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "95%" },
                  maxWidth: 720,
                  aspectRatio: "16/9",
                  borderRadius: 2,
                  overflow: "hidden",
                  boxShadow: 6,
                  border: "4px solid rgba(255,255,255,0.06)",
                  transformOrigin: "center",
                }}
              >
                <motion.div
                  style={{ width: "100%", height: "100%" }}
                  initial={{ scale: 1 }}
                  animate={{ scale: [1, 1.01, 1] }}
                  transition={{
                    repeat: Infinity,
                    duration: 8,
                    ease: "easeInOut",
                  }}
                >
                  <iframe
                    title="Hero YouTube video"
                    src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      width: "100%",
                      height: "100%",
                      border: 0,
                      display: "block",
                    }}
                  />
                </motion.div>
              </Box>
            </Grid>

            <Grid
              component={motion.div}
              variants={itemVariantsRight}
              size={{ xs: 12, md: 6 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    mt: 2,
                    lineHeight: 1.05,
                    color: "#6d1675",
                    fontWeight: "bold",
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Know Us
                </Typography>

                <Typography
                  sx={{
                    color: "#333",
                    opacity: 0.95,
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    textAlign: "justify",
                    mt: 2,
                  }}
                >
                  Shree Krishnayan Desi Gauraksha Evam Gaulok Dham Sewa Samiti’
                  is one of the largest Gaurakshashala of Desi cows in India. We
                  protect, feed & shelter ailing, starving, destitute and stray
                  Desi Cows & Bulls, the majority of which are abandoned by
                  their owners or saved from butchers. Most of these Gauvansh
                  are milk barren. These cows are brought to our Gaushala from
                  tough conditions. All these cows are fed, sheltered, and
                  looked after by hundreds of Gausewaks who work round the
                  clock.
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mt: -2 }}>
                <Button
                  sx={{
                    bgcolor: "transparent",
                    color: "#ffc20f",
                    fontWeight: "bold",
                    py: 1.2,
                  }}
                  endIcon={<ArrowForward />}
                >
                  Read More
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ py: 4, bgcolor: "#fef5ff" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 20, md: 30 },
                fontWeight: "bold",
                color: "#6d1675",
                textAlign: "center",
              }}
            >
              What We Do
            </Typography>

            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
          </Box>
          <Box
            sx={{
              height: { xs: "400px", md: "500px" },
              position: "relative",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 2,
            }}
          >
            {cardsData.map((banner, i) => {
              const pos = getPositiond(i);

              let style = {};
              if (pos === "center") {
                style = { scale: 1, x: 0, zIndex: 3, opacity: 1 };
              } else if (pos === "left") {
                style = { scale: 0.8, x: "-60%", zIndex: 2, opacity: 0.9 };
              } else if (pos === "right") {
                style = { scale: 0.8, x: "60%", zIndex: 2, opacity: 0.9 };
              } else {
                style = { scale: 0.5, opacity: 0, zIndex: 1 };
              }
              const isExpanded = expandedCard === i;

              return (
                <motion.div
                  key={i}
                  id={`card-${i}`}
                  animate={style}
                  transition={{ duration: 0.8 }}
                  style={{
                    position: "absolute",
                    width: { xs: "100%", md: "50%" },
                    maxWidth: "50%",
                    textAlign: "center",
                    zIndex: style.zIndex,
                    cursor: "pointer",
                  }}
                  onClick={() => handleCardClick(i)}
                >
                  <Card
                    sx={{
                      bgcolor: "white",
                      borderRadius: 2,
                      mx: "auto",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    <CardContent sx={{ p: { xs: 1, d: 2 } }}>
                      <img
                        src={banner.img}
                        alt={banner.title}
                        style={{
                          width: "100%",
                          height: { xs: 200, md: 300 },
                          objectFit: "cover",
                          borderRadius: 15,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: 18, md: 22 },
                          fontWeight: "bold",
                          mt: 2,
                        }}
                      >
                        {banner.title}
                      </Typography>
                      <Typography sx={{ mt: 1, fontSize: 14 }}>
                        {readMore[i] || isExpanded
                          ? banner.desc
                          : `${banner.desc.substring(0, 100)}...`}
                        {banner.desc.length > 100 && !isExpanded && (
                          <Typography
                            sx={{
                              fontSize: { xs: 14, md: 16 },
                              color: "red",
                              cursor: "pointer",
                              mt: 1,
                              fontWeight: "bold",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleReadMore(i);
                              // Scroll the card content down when clicked
                              const cardDiv = document.getElementById(
                                `card-${i}`
                              );
                              if (cardDiv) {
                                cardDiv.scrollIntoView({
                                  behavior: "smooth",
                                  block: "start",
                                });
                              }
                            }}
                          >
                            {readMore[i] ? "Read Less" : "Read More"}
                          </Typography>
                        )}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              );
            })}

            <IconButton
              onClick={handlePrevs}
              sx={{
                position: "absolute",
                left: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowBackIos fontSize="small" />
            </IconButton>

            {/* Right Arrow */}
            <IconButton
              onClick={handleNexts}
              sx={{
                position: "absolute",
                right: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            textAlign: "center",
            px: { xs: 2, md: 6 },
            py: 15,
            bgcolor: "#ffff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 20, md: 30 },
                fontWeight: "bold",
                color: "#6d1675",
                textAlign: "center",
              }}
            >
              Our Achievements
            </Typography>

            {/* Right flower symbol */}
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
          </Box>
          <Typography
            sx={{ mb: 4, mt: -2, color: "#6e6966", fontWeight: "bold" }}
          >
            We, at Shree Krishnayan take immense pride in our accomplishments,
            which reflect our unwavering dedication to the welfare of Gauvansh
            (cows) and the broader community. Over the years, our efforts have
            been recognized and celebrated by various governmental &
            non-governmental bodies and esteemed individuals, underscoring the
            impact and importance of our work.{" "}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <IconButton
              onClick={goToPrevious}
              sx={{
                display: { xs: "none", md: "inline-flex" },
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                boxShadow: 2,
              }}
            >
              <ArrowBackIosIcon sx={{ color: "red" }} />
            </IconButton>

            {/* Cards container */}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 2,
                overflowX: { xs: "auto", md: "visible" },
                justifyContent: { xs: "flex-start", md: "center" },
                px: { xs: 1, md: 0 },
                scrollSnapType: { xs: "x mandatory", md: "none" },
              }}
            >
              {visibleCards.map((achieve, idx) => {
                const realIndex = (startIndex + idx) % achievementsData.length;
                return (
                  <Card
                    key={realIndex}
                    sx={{
                      width: { xs: "90%", md: 350 },
                      flexShrink: 0,
                      border: "1px double black",
                      borderRadius: 2,
                      scrollSnapAlign: { xs: "center", md: "none" },
                      display: "flex",
                      flexDirection: "column",
                      height: readMore[realIndex] ? "auto" : 400,
                      transition: "height 0.3s ease",
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: 2,
                        border: "1px double black",
                        m: 0.5,
                        flex: 1,
                      }}
                    >
                      <img
                        src={achieve.image}
                        alt=""
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontSize: 18,
                          fontWeight: "bold",
                          mt: 1,
                        }}
                      >
                        {achieve.title}
                      </Typography>
                      <Typography sx={{ mt: 1, textAlign: "center" }}>
                        {readMore[realIndex]
                          ? achieve.description
                          : achieve.description.substring(0, 80) + "..."}
                      </Typography>
                      <Button
                        onClick={() => toggleDescription(realIndex)}
                        sx={{ mt: 1, color: "red", fontWeight: "bold" }}
                      >
                        {readMore[realIndex] ? "Read Less" : "Read More"}
                      </Button>
                    </CardContent>
                  </Card>
                );
              })}
            </Box>

            <IconButton
              onClick={goToNext}
              sx={{
                display: { xs: "none", md: "inline-flex" },
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                boxShadow: 2,
              }}
            >
              <ArrowForwardIosIcon sx={{ color: "red" }} />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ bgcolor: "#fef5ff", p: { xs: 2, md: 4 } }}>
          <Box
            sx={{
              mt: -18,
              p: { xs: 2, md: 4 },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // width: { xs: "90%", md: "90%" },
              mx: "auto",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "100%" },
                bgcolor: { xs: "transparent", md: "#fff" },
                boxShadow: { xs: 0, md: 5 },
                height: 250,
                borderRadius: "10px 0px 0px 10px",
              }}
            >
              <Box
                sx={{
                  width: { xs: "50%", md: "100%" },
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: "100%", md: "380px" },
                    height: { xs: "200px", md: 200 },
                    mt: 3,
                  }}
                >
                  {cards.map((card, i) => {
                    const position = getCardPosition(i);

                    return (
                      <motion.div
                        key={i}
                        animate={position}
                        transition={{ duration: 0.5 }}
                        style={{
                          position: "absolute",
                          display: { xs: "none", md: "block" },
                          top: 0,
                          left: { xs: "-80%", md: "50%" },
                          transform: "translateX(-50%)",
                          width: "100%",
                          height: "100%",

                          zIndex: position.zIndex || 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            bgcolor: "#ffc20f",
                            borderRadius: 2,
                            boxShadow: 10,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            ml: { xs: 9, md: 30 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 30, md: 40 },
                              color: "#6d1675",
                              mt: 2,
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            {card.action}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: 16, md: 22, textAlign: "center" },
                              fontWeight: "bold",
                              color: "#333",
                              lineHeight: 1.2,
                            }}
                          >
                            {card.title}
                          </Typography>
                        </Box>
                      </motion.div>
                    );
                  })}

                  <IconButton
                    onClick={handleCardPrev}
                    sx={{
                      position: "absolute",
                      left: { xs: -20, md: 10 },
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                      bgcolor: "rgba(255,255,255,0.7)",
                      "&:hover": { bgcolor: "white" },
                      p: { xs: 0.5, md: 1.5 },
                    }}
                  >
                    <ArrowBackIos fontSize="small" />
                  </IconButton>

                  <IconButton
                    onClick={handleCardNext}
                    sx={{
                      position: "absolute",
                      right: { xs: -180, md: -500 },
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                      bgcolor: "rgba(255,255,255,0.7)",
                      "&:hover": { bgcolor: "white" },
                      p: { xs: 0.5, md: 1.5 },
                    }}
                  >
                    <ArrowForwardIos fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                p: 4,
                width: "20%",
                height: 190,
                bgcolor: "#6d1675",
                boxShadow: 5,
                borderRadius: "0px 10px 10px 0px",
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: 22,
                  fontWeight: "bold",
                  color: "#fff",
                  lineHeight: 1.2,
                }}
              >
                Our Goal is to
                <br />
                Save Gauvansh
              </Typography>
              <Typography
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "#fff",
                }}
              >
                Become Volunteer{" "}
                <span style={{ marginLeft: 8, fontSize: 20 }}>→</span>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ bgcolor: "#fef5ff", p: { xs: 2, md: 4 } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 20, md: 30 },
                fontWeight: "bold",
                color: "#6d1675",
                textAlign: "center",
              }}
            >
              Accreditations & Recognitions
            </Typography>

            {/* Right flower symbol */}
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
          </Box>
          <Typography
            sx={{
              mb: 4,
              mt: -2,
              color: "#6e6966",
              fontWeight: "bold",
              // width: 850,
              mx: "auto",
              textAlign: "center",
              fontSize: { xs: 14, md: 15 },
            }}
          >
            We are registered with the Animal Welfare Board of India (Chennai)
            and various state animal welfare boards. Our accreditations and
            recognitions include FCRA under the Ministry of Home Affairs, Niti
            Ayog, Government of India, Uttar Pradesh Gau Sewa Ayog, registration
            under section 12AA of the Income Tax Act, Uttarakhand Animal
            Development Board, Madhya Pradesh Gausewa Ayog, and registration
            under section 80G of the Income Tax Act.
          </Typography>
          <Box
            sx={{
              position: "relative",
              width: `${visibleCount * (cardWidth + gap) - gap}px`,
              mx: "auto",
            }}
          >
            <IconButton
              onClick={() =>
                setShift(
                  (prev) =>
                    (prev - 1 + accreditations.length) % accreditations.length
                )
              }
              sx={{
                position: "absolute",
                top: "50%",
                left: -50,
                transform: "translateY(-50%)",
                zIndex: 20,
                width: 40,
                height: 40,
                boxShadow: 1,
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
              }}
            >
              <ArrowBackIosIcon sx={{ color: "red" }} />
            </IconButton>

            <Box sx={{ overflow: "hidden" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: `${gap}px`,
                  transform: `translateX(-${shift * (cardWidth + gap)}px)`,
                  transition: "transform 0.5s ease",
                  p: { xs: 2, md: 4 },
                }}
              >
                {carouselItems.map((item, i) => (
                  <Card
                    key={i}
                    sx={{
                      minWidth: { xs: 200, md: cardWidth },
                      textAlign: "center",
                      boxShadow: 2,
                      borderRadius: 5,
                      bgcolor: "#fff",
                      border: "3px solid #ffc20f",
                    }}
                  >
                    <CardContent>
                      <img
                        src={item.img}
                        alt={item.text}
                        style={{ width: 100, height: 100, objectFit: "cover" }}
                      />
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: 14,
                          width: 150,
                          mx: "auto",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.text}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Box>

            <IconButton
              onClick={() =>
                setShift((prev) => (prev + 1) % accreditations.length)
              }
              sx={{
                position: "absolute",
                top: "50%",
                right: -50,
                transform: "translateY(-50%)",

                zIndex: 20,
                width: 40,
                height: 40,
                boxShadow: 1,
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
              }}
            >
              <ArrowForwardIosIcon sx={{ color: "red" }} />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ py: 4, bgcolor: "#ffff" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 20, md: 30 },
                fontWeight: "bold",
                color: "#6d1675",
                textAlign: "center",
              }}
            >
              Book Your Sewa
            </Typography>

            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
          </Box>
          <Typography
            sx={{
              mb: 4,
              mt: -2,
              color: "#6e6966",
              fontWeight: "bold",
              // width: 850,
              mx: "auto",
              textAlign: "center",
            }}
          >
            Spreading kindness through gaudaan, food distribution, pooja, and
            many more.{" "}
          </Typography>

          <Box
            sx={{
              height: { xs: "400px", md: "500px" },
              position: "relative",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: { xs: 0, md: 5 },
            }}
          >
            {sewa.map((sewa, i) => {
              const pos = getPositiond(i);
              let style = {};
              if (pos === "center") {
                style = { scale: 1, x: 0, zIndex: 3, opacity: 1 };
              } else if (pos === "left") {
                style = { scale: 0.8, x: "-60%", zIndex: 2, opacity: 0.9 };
              } else if (pos === "right") {
                style = { scale: 0.8, x: "60%", zIndex: 2, opacity: 0.9 };
              } else {
                style = { scale: 0.5, x: 0, zIndex: 1, opacity: 0 };
              }

              return (
                <motion.div
                  key={i}
                  id={`card-${i}`}
                  animate={style}
                  transition={{ duration: 0.8 }}
                  style={{
                    position: "absolute",
                    width: { xs: "100%", md: "50%" },
                    maxWidth: "50%",
                    textAlign: "center",
                    zIndex: style.zIndex,
                    cursor: "pointer",
                  }}
                  onClick={() => handleCardClick(i)}
                >
                  <Card
                    sx={{
                      bgcolor: "white",
                      borderRadius: 5,
                      mx: "auto",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    <CardContent sx={{ p: 2 }}>
                      <img
                        src={sewa.image}
                        alt={sewa.title}
                        style={{
                          width: "100%",
                          height: { xs: 200, md: 300 },
                          objectFit: "cover",
                          borderRadius: 15,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: 18, md: 24 },
                          fontWeight: "bold",
                          mt: 2,
                        }}
                      >
                        {sewa.title}
                      </Typography>
                      <Typography sx={{ fontSize: { xs: 14, md: 16 }, mt: 2 }}>
                        {sewa.description}
                      </Typography>
                      <Button
                        sx={{
                          mt: 2,
                          bgcolor: "#ffc20f",
                          width: "90%",
                          color: "#6d1675",
                          fontWeight: "BOLD",
                          textTransform: "none",
                          fontSize: { xs: 12, md: 16 },
                          borderRadius: 5,
                        }}
                      >
                        Add Item to Donate
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              );
            })}

            <IconButton
              onClick={handlePrevs}
              sx={{
                position: "absolute",
                left: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowBackIos fontSize="small" />
            </IconButton>

            {/* Right Arrow */}
            <IconButton
              onClick={handleNexts}
              sx={{
                position: "absolute",
                right: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            backgroundImage: `url(${banner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            p: { xs: 2, md: 6 },
            borderRadius: 2,
            minHeight: { xs: 200, md: 400 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 20, md: 30 },
                fontWeight: "bold",
                color: "#6d1675",
                textAlign: "center",
              }}
            >
              Adopt A Cow
            </Typography>

            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
          </Box>
          <Typography
            sx={{
              mt: -2,
              color: "#6e6966",
              fontWeight: "bold",
              // width: 850,
              mx: "auto",
              textAlign: "center",
            }}
          >
            Select your mother cow / calf/ bull and adopt them & interact with
            it.
          </Typography>
          <Box
            sx={{
              height: { xs: "400px", md: "500px" },
              position: "relative",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: { xs: 0, md: 5 },
            }}
          >
            {adopt.map((adopt, i) => {
              const pos = getAdoptPosition(i);

              let style = {};
              if (pos === "center") {
                style = { scale: 1, x: 0, zIndex: 5, opacity: 1 };
              } else if (pos === "left2") {
                style = { scale: 0.9, x: "-40%", zIndex: 4, opacity: 0.9 };
              } else if (pos === "left1") {
                style = { scale: 0.8, x: "-80%", zIndex: 3, opacity: 0.7 };
              } else if (pos === "right2") {
                style = { scale: 0.9, x: "40%", zIndex: 4, opacity: 0.9 };
              } else if (pos === "right1") {
                style = { scale: 0.8, x: "80%", zIndex: 3, opacity: 0.7 };
              } else {
                style = { scale: 0.5, x: 0, zIndex: 1, opacity: 0 };
              }

              return (
                <motion.div
                  key={i}
                  animate={style}
                  transition={{ duration: 0.8 }}
                  style={{
                    position: "absolute",
                    width: "50%",
                    maxWidth: "500px",
                    textAlign: "center",
                    zIndex: style.zIndex,
                    cursor: "pointer",
                  }}
                  onClick={() => handleCardClick(i)}
                >
                  <Card sx={{ borderRadius: 5, height: "auto" }}>
                    <CardContent sx={{ p: 2 }}>
                      <img
                        src={adopt.image}
                        alt={adopt.title}
                        style={{
                          width: "100%",
                          height: { xs: 200, md: 300 },
                          objectFit: "cover",
                          borderRadius: 15,
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", md: "row" }, // justifyContent: "space-between",
                          gap: { xs: 0, md: 20 },
                          mt: 2,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "row", md: "column" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              textAlign: "left",
                            }}
                          >
                            Category:
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {adopt.categary}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "row", md: "column" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              textAlign: "left",
                            }}
                          >
                            Breed:
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {adopt.breed}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", md: "row" },
                          gap: { xs: 0, md: 20 },
                          mt: 2,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "row", md: "column" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 10, md: 15 },
                              textAlign: "left",
                            }}
                          >
                            Date of Birth:
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {adopt.date}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "row", md: "column" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              textAlign: "left",
                            }}
                          >
                            Age:
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: 12, md: 15 },
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {adopt.age}
                          </Typography>
                        </Box>
                      </Box>

                      <Button
                        sx={{
                          mt: 2,
                          bgcolor: "#ffc20f",
                          width: "90%",
                          color: "#6d1675",
                          fontWeight: "bold",
                          textTransform: "none",
                          fontSize: { xs: 10, nd: 16 },
                          borderRadius: 5,
                        }}
                      >
                        Add Item to Donate
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              );
            })}

            <IconButton
              onClick={handleAdoptPrev}
              sx={{
                position: "absolute",
                left: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowBackIos fontSize="small" />
            </IconButton>

            {/* Right Arrow */}
            <IconButton
              onClick={handleAdoptNext}
              sx={{
                position: "absolute",
                right: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ p: { xs: 2, md: 6 } }}>
          <Typography
            sx={{
              fontSize: { xs: 20, md: 30 },
              fontWeight: "bold",
              color: "#6d1675",
              textAlign: "center",
              mb: 3,
            }}
          >
            Blog
          </Typography>
          <Typography
            sx={{
              mt: -2,
              color: "#6e6966",
              fontWeight: "bold",
              mx: "auto",
              textAlign: "center",
            }}
          >
            Select your favorite blog & explore.
          </Typography>

          <Box
            sx={{
              height: { xs: "220px", md: "500px" },
              position: "relative",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {blog.map((item, i) => {
              const pos = getBlogPosition(i);

              let style = {};
              if (pos === "center")
                style = { scale: 1, x: 0, zIndex: 5, opacity: 1 };
              else if (pos === "left2")
                style = { scale: 0.9, x: "-40%", zIndex: 4, opacity: 0.9 };
              else if (pos === "left1")
                style = { scale: 0.8, x: "-80%", zIndex: 3, opacity: 0.7 };
              else if (pos === "right2")
                style = { scale: 0.9, x: "40%", zIndex: 4, opacity: 0.9 };
              else if (pos === "right1")
                style = { scale: 0.8, x: "80%", zIndex: 3, opacity: 0.7 };
              else style = { scale: 0.5, x: 0, zIndex: 1, opacity: 0 };
              return (
                <motion.div
                  key={i}
                  animate={style}
                  transition={{ duration: 0.8 }}
                  style={{
                    position: "absolute",
                    width: "50%",
                    maxWidth: "500px",
                    textAlign: "center",
                    zIndex: style.zIndex,
                    cursor: "pointer",
                  }}
                >
                  <Card sx={{ borderRadius: 5 }}>
                    <CardContent sx={{ p: { xs: 1, md: 2 } }}>
                      <img
                        src={item.image}
                        alt={item.title}
                        style={{
                          width: "100%",
                          height: { xs: 200, md: 300 },
                          objectFit: "cover",
                          borderRadius: 10,
                        }}
                      />
                      <Typography
                        sx={{
                          mt: 2,
                          fontWeight: "bold",
                          fontSize: { xs: 15, md: 20 },
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          mt: 1,
                          color: "#6e6966",
                          fontSize: { xs: 12, md: 15 },
                          fontWeight: "bold",
                        }}
                      >
                        {item.date}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              );
            })}

            {/* Left Arrow */}
            <IconButton
              onClick={Prev}
              sx={{
                position: "absolute",
                left: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowBackIos fontSize="small" />
            </IconButton>

            {/* Right Arrow */}
            <IconButton
              onClick={Next}
              sx={{
                position: "absolute",
                right: { xs: 10, md: 20 },
                top: "50%",
                transform: "translateY(-50%)",
                color: "red",
                bgcolor: "rgba(255,255,255,0.7)",
                "&:hover": { bgcolor: "white" },
                zIndex: 5,
                p: { xs: 0.5, md: 1.5 },
              }}
            >
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ bgcolor: "#fff", p: { xs: 2, md: 6 } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 20, md: 30 },
                fontWeight: "bold",
                color: "#6d1675",
                textAlign: "center",
              }}
            >
              Testimonials
            </Typography>
            <Typography sx={{ fontSize: { xs: 24, md: 30 }, color: "#F27449" }}>
              ✿
            </Typography>
          </Box>

          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <IconButton
              onClick={prevSlide}
              sx={{
                display: { xs: "none", md: "block" },
                position: "absolute",
                left: 10,
                zIndex: 3,
                bgcolor: "#F27449",
                color: "#fff",
                "&:hover": { bgcolor: "#d95f38" },
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: 350,
              }}
            >
              {testimonials.map((t, i) => {
                const pos = getSlidPosition(i);
                let style = {};

                if (pos === "center") {
                  style = { scale: 1, x: 0, zIndex: 3, opacity: 1 };
                } else if (pos === "left") {
                  style = { scale: 0.8, x: "-30%", zIndex: 2, opacity: 0.9 };
                } else if (pos === "right") {
                  style = { scale: 0.8, x: "30%", zIndex: 2, opacity: 0.9 };
                } else {
                  style = { scale: 0.5, opacity: 0, zIndex: 1 };
                }
                return (
                  <motion.div
                    key={i}
                    animate={style}
                    transition={{ duration: 0.6 }}
                    style={{
                      position: "absolute",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Card
                      sx={{
                        width: { xs: "90%", md: 500 },
                        p: 3,
                        borderRadius: 3,
                        boxShadow: 4,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mb: 2,
                        }}
                      >
                        <Avatar
                          src={t.img}
                          sx={{
                            width: 90,
                            height: 90,
                            border: "4px solid #f7e1d4",
                          }}
                        />
                      </Box>
                      <CardContent>
                        <Typography
                          variant="h6"
                          sx={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          {t.name}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ textAlign: "center", mb: 2 }}
                        >
                          {t.role}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{ textAlign: "center", mb: 2 }}
                        >
                          {t.text}
                        </Typography>
                      </CardContent>
                    </Card>
                  </motion.div>
                );
              })}
            </Box>

            <IconButton
              onClick={nextSlide}
              sx={{
                display: { xs: "none", md: "block" },
                position: "absolute",
                right: 10,
                zIndex: 3,
                bgcolor: "#F27449",
                color: "#fff",
                "&:hover": { bgcolor: "#d95f38" },
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default Gaudaan;

